// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"Dashboard_dashboardContainer__nQji6","mainContent":"Dashboard_mainContent__7T-3n"};